module.exports = __webpack_public_path__ + "img/banner.312a5510.png";